"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reduxPromise = _interopRequireDefault(require("redux-promise"));

var _nuiShell = require("@concur/nui-shell");

var _rootReducer = _interopRequireDefault(require("./rootReducer"));

var _utils = require("../utils");

var _DevTools = _interopRequireDefault(require("./DevTools"));

var _analytics = _interopRequireDefault(require("../analytics/analytics"));

var _listingModule = require("../listing/listingModule");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDebugSessionKey() {
  // By default we try to read the key from ?debug_session=<key> in the address bar
  var matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
  return matches && matches.length > 0 ? matches[1] : null;
}

var store = null;

function configureStore(initialState) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var utilityFns = arguments.length > 2 ? arguments[2] : undefined;

  if (!initialState.userPrefs.userId) {
    initialState.userPrefs = _objectSpread({}, initialState.userPrefs, {
      userId: ''
    });
  }

  var createStoreWithMiddleware;

  var customReduxMiddleware = _nuiShell.nuiReduxMiddlewares.customize({
    analytics: function analytics(mw) {
      return mw.withOptions({
        mapStateToAnalytics: _analytics.default
      });
    }
  });

  if (process.env.NODE_ENV !== 'production' && _utils.isClient && typeof __DEVTOOLS__ !== 'undefined' && __DEVTOOLS__) {
    var createLogger = require('redux-logger');

    var _require = require('redux-devtools'),
        persistState = _require.persistState;

    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
      createStoreWithMiddleware = composeEnhancers(_redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default, createLogger({
        level: 'info',
        collapsed: true
      })])), persistState(getDebugSessionKey()))(_redux.createStore);
    } else {
      createStoreWithMiddleware = (0, _redux.compose)(_redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default, createLogger({
        level: 'info',
        collapsed: true
      })])), _DevTools.default.instrument(), persistState(getDebugSessionKey()))(_redux.createStore);
    }
  } else if (process.env.QA_REDUX_LOGGING) {
    var _createLogger = require('redux-logger');

    createStoreWithMiddleware = _redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default, _createLogger({
      level: 'info',
      collapsed: true
    })]))(_redux.createStore);
  } else {
    createStoreWithMiddleware = _redux.applyMiddleware.apply(void 0, [_reduxThunk.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise.default]))(_redux.createStore);
  }

  if (!_utils.isClient) {
    // this only works with webpack because of the Ignore plugin in config
    var ConcurProtect = require('@concur/concur-protect'); // TripIt expects to decode using `_protectKey` from session
    // ConcurProtect knowns to grab this field and use it if present


    var otProtectCSRF = new ConcurProtect(req.session);
    var encryptUserId = utilityFns.encryptUserId;

    if (req.session && req.session.UserID) {
      initialState.userPrefs = _objectSpread({}, initialState.userPrefs, {
        userId: encryptUserId(req.session.UserID),
        csrf_token: otProtectCSRF.protectValue('csrf_token', req.session.SessionId)
      });
    }

    var originalhost = req.headers['original-host'] || '';
    initialState.meta = _objectSpread({}, initialState.meta, {
      originalhost: originalhost,
      listingNotFound: req.listingNotFound
    });
    initialState.baseUrl = (0, _utils.getNuiBaseUrlFromHost)(originalhost);
  }

  if (req.data) {
    initialState.listing = _objectSpread({}, _listingModule.initialState, _defineProperty({}, req.listingId, {
      readyState: _listingModule.LISTING_FETCHED,
      data: req.data
    }));
  }

  if (req.location) {
    initialState.listing = _objectSpread({}, initialState.listing, {
      localizedRegions: req.location.localizedRegions,
      localizedCountries: req.location.localizedCountries
    });
  }

  if (req.userProfile) {
    initialState.userProfile = req.userProfile;
  }

  store = createStoreWithMiddleware(_rootReducer.default, initialState);
  return store;
}


//////////////////
// WEBPACK FOOTER
// ./lib/app/configureStore.js
// module id = 89
// module chunks = 0